import axios from 'axios';
import authHeader from "../../services/auth-header";
import ConstApiUrls from "../../services/const-api-urls";

const API_URL = ConstApiUrls.API_SERVICE_URL

class FDistributionChannelService {
    getApiUrl() {
        return API_URL
    }

    getAllFDistributionChannel(){
        return axios.get(API_URL + `getAllFDistributionChannel`, { headers: authHeader() });
    }
    getAllFDistributionChannelSimple(){
        return axios.get(API_URL + `getAllFDistributionChannelSimple`, { headers: authHeader() });
    }
    getAllFDistributionChannelByCompany(){
        return axios.get(API_URL + `getAllFDistributionChannelByCompany`, { headers: authHeader() });
    }
    getAllFDistributionChannelByCompanySimple(){
        return axios.get(API_URL + `getAllFDistributionChannelByCompanySimple`, { headers: authHeader() });
    }

    getAllFDistributionChannelContaining(page, pageSize, sortBy, order, search){
        // return axios.get(API_URL + `getAllFDistributionChannel`, { headers: authHeaderMultipart() });
        return axios.get(API_URL + `getAllFDistributionChannelContaining?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&order=${order}&search=${search}`, { headers: authHeader() });
    }
    getFDistributionChannelById(id){
        return axios.get(API_URL + `getFDistributionChannelById/${id}`, { headers: authHeader() });
    }
    updateFDistributionChannel(item){
        return axios.put(API_URL + `updateFDistributionChannel/${item.id}`, item, {headers: authHeader()})
    }
    createFDistributionChannel(item){
        return axios.post(API_URL + `createFDistributionChannel`, item, {headers: authHeader()})
    }
    deleteFDistributionChannel(id){
        return axios.delete(API_URL + `deleteFDistributionChannel/${id}`, {
            headers: authHeader()
        });
    }
    deleteAllFDistributionChannel(itemIds){
        // let user = JSON.parse(localStorage.getItem('user'));
        // return axios.delete(API_URL + `deleteAllFDistributionChannel`, {
        //     headers:  authHeaderMultipart(),
        //     data: {
        //         message: 'delete  success'
        //     }
        // });
        return axios.delete(API_URL + `deleteAllFDistributionChannel`, {
            headers:  authHeader(),
            data: itemIds
        });


    }
}
export default new FDistributionChannelService()